export default function errMessage(error, default_message = 'Unknown error') {
    return (error && error.response && error.response.data)
        ? (error.response.data.err_message || error.response.data.message || default_message)
        : (error ? error.err_message || error.message || default_message : default_message)
}
